import './ContentPage.css';
import Footer from '../components/Footer.js'; 

const Support = ({ title, content }) => {
  return (
    <div>
    <div className="content-page">
      <section className="content-hero">
        <h1 className="hero-title">Support Services</h1>
        <div className="hero-decor"></div>
      </section>

      <section className="content-section">
        <div className="content-card reveal active">
          <div className="text-container">
            <p className="content-text"><h4>Notarial Services</h4>Provision of certified notarization to formally authenticate legal documents and signatures.</p>
             <p className="content-text"><h4>Oath Commissioning & Statutory Declarations</h4>Administration of oaths, affirmations, and statutory declarations in compliance with legal requirements.</p>
              <p className="content-text"><h4>Corporate Secretarial Services</h4>Support in maintaining statutory registers, filing corporate returns, and ensuring governance compliance.</p>
               <p className="content-text"><h4>Financial Legal Advisory</h4>Legal counsel on financial structuring, investment planning, and asset protection strategies.</p>
                <p className="content-text"><h4>Tax Advisory & Compliance</h4>Strategic legal advice on tax planning, regulatory compliance, and minimizing tax liability within legal frameworks.</p>
                 <p className="content-text"><h4>Pro Bono Child Advocacy</h4>Free legal representation and advocacy to uphold the rights and welfare of minors in legal matters.</p>
                  <p className="content-text"><h4>Common Law Advisory</h4>Comprehensive legal services in areas governed by common law, including contracts, torts, and real property.</p>
          </div>
          <div className="interactive-element">
            <div className="hover-circle"></div>
            <div className="hover-circle"></div>
          </div>
        </div>
      </section>

    </div>
          <Footer />
    </div>
  );
};

export default Support;